import { Adresa } from './adresa';
import { BankoveSpojenie } from './bankove-spojenie';
import { ExtendedHistoriaResponse } from './extended-historia-response';
import { KontaktnaKarta } from './kontaktna-karta';
import { Organizacia } from './organizacia';
import { Osoba } from './osoba';
import { OsobaSubjektu } from './osoba-subjektu';
import { SubjRef } from './subj-ref';
import { SubjektKontaktnaOsoba } from './subjekt-kontaktna-osoba';

/**
 * 
 * @export
 * @interface Subjekt
 */
export interface Subjekt {
    /**
     * 
     * @type {Array<BankoveSpojenie>}
     * @memberof Subjekt
     */
    'bankoveSpojenia'?: Array<BankoveSpojenie>;
    /**
     * 
     * @type {Array<SubjektKontaktnaOsoba>}
     * @memberof Subjekt
     */
    'kontaktneOsoby'?: Array<SubjektKontaktnaOsoba>;
    /**
     * 
     * @type {Array<KontaktnaKarta>}
     * @memberof Subjekt
     */
    'kontakty'?: Array<KontaktnaKarta>;
    /**
     * 
     * @type {Adresa}
     * @memberof Subjekt
     */
    'korespondencnaAdresa'?: Adresa;
    /**
     * 
     * @type {ExtendedHistoriaResponse}
     * @memberof Subjekt
     */
    'meta'?: ExtendedHistoriaResponse;
    /**
     * 
     * @type {Organizacia}
     * @memberof Subjekt
     */
    'organizacia'?: Organizacia;
    /**
     * 
     * @type {Osoba}
     * @memberof Subjekt
     */
    'osoba'?: Osoba;
    /**
     * 
     * @type {Array<OsobaSubjektu>}
     * @memberof Subjekt
     */
    'osobySubjektu'?: Array<OsobaSubjektu>;
    /**
     * 
     * @type {boolean}
     * @memberof Subjekt
     */
    'overenaIdentita'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Subjekt
     */
    'overeneData'?: boolean;
    /**
     * 
     * @type {SubjRef}
     * @memberof Subjekt
     */
    'subjektRef'?: SubjRef;
    /**
     * 
     * @type {string}
     * @memberof Subjekt
     */
    'typ'?: SubjektTypEnum;
}

export const SubjektTypEnum = {
    Osoba: 'OSOBA',
    Organizacia: 'ORGANIZACIA'
} as const;

export type SubjektTypEnum = typeof SubjektTypEnum[keyof typeof SubjektTypEnum];


